import { Avatar, Button, Tooltip } from "@productlane/ui"

import { portalPath } from "@/lib/portal-instances"
import { usePortalMarkById } from "@/lib/use-portal-marks"
import { useZeroWorkspace } from "@/lib/zero"
import { portalHostname } from "@/screens/settings/portal-instance-form"
import { useThreadContext } from "../../thread-context"

/**
 * Read only: a thread's portal is decided by where the customer wrote from.
 * Threads with no portal of their own say nothing rather than claiming the main
 * portal, which would be wrong for every email and Slack thread.
 */
export function ThreadPortalRow() {
	const { thread } = useThreadContext()
	const workspace = useZeroWorkspace()
	const marks = usePortalMarkById()

	const mark = thread.portalInstanceId
		? marks.get(thread.portalInstanceId)
		: undefined
	if (!mark || !workspace) return null

	const url = `https://${portalHostname(workspace)}${portalPath(mark)}`

	return (
		<Tooltip label={`Open the ${mark.name} portal`}>
			<a href={url} target="_blank" rel="noreferrer" className="max-w-full">
				<Button
					variant="ghost"
					Icon={() => (
						<Avatar
							name={mark.name}
							image={mark.logoUrl}
							colorSeed={mark.colorSeed}
							roundness="sm"
							size="xxs"
							className="flex-none"
						/>
					)}
					className="h-auto min-w-[145px] max-w-full justify-start text-xs !text-primary"
				>
					<span className="truncate">{mark.name}</span>
				</Button>
			</a>
		</Tooltip>
	)
}
